import { Stat } from "../../types/enum/Game"
import { Item, ItemsSoldAtTown } from "../../types/enum/Item"

export const ItemStats: { [item in Item]?: { [stat in Stat]?: number } } = {
  [Item.TWISTED_SPOON]: { [Stat.AP]: 10 },
  [Item.MAGNET]: { [Stat.SPEED]: 10 },
  [Item.BLACK_GLASSES]: { [Stat.CRIT_CHANCE]: 10 },
  [Item.MIRACLE_SEED]: { [Stat.HP]: 15 },
  [Item.CHARCOAL]: { [Stat.ATK]: 3 },
  [Item.NEVER_MELT_ICE]: { [Stat.SPE_DEF]: 3 },
  [Item.HEART_SCALE]: { [Stat.DEF]: 3 },
  [Item.MYSTIC_WATER]: { [Stat.PP]: 15 },
  [Item.OLD_AMBER]: {},
  [Item.DAWN_STONE]: { [Stat.AP]: 20 },
  [Item.WATER_STONE]: { [Stat.PP]: 30 },
  [Item.THUNDER_STONE]: { [Stat.SPEED]: 20 },
  [Item.FIRE_STONE]: { [Stat.ATK]: 6 },
  [Item.MOON_STONE]: { [Stat.DEF]: 6 },
  [Item.DUSK_STONE]: { [Stat.CRIT_CHANCE]: 20 },
  [Item.LEAF_STONE]: { [Stat.HP]: 30 },
  [Item.ICE_STONE]: { [Stat.SPE_DEF]: 6 },
  [Item.CHOICE_SPECS]: { [Stat.AP]: 100 },
  [Item.SOUL_DEW]: {},
  [Item.UPGRADE]: { [Stat.AP]: 10, [Stat.SPEED]: 10 },
  [Item.REAPER_CLOTH]: { [Stat.AP]: 10, [Stat.CRIT_CHANCE]: 20 },
  [Item.POKEMONOMICON]: { [Stat.AP]: 30, [Stat.ATK]: 3 },
  [Item.POWER_LENS]: { [Stat.SPE_DEF]: 10, [Stat.AP]: 10 },
  [Item.SHELL_BELL]: { [Stat.ATK]: 5, [Stat.SPE_DEF]: 5 },
  [Item.HEAVY_DUTY_BOOTS]: { [Stat.AP]: 40, [Stat.DEF]: 12 },
  [Item.AQUA_EGG]: { [Stat.PP]: 30 },
  [Item.BLUE_ORB]: { [Stat.PP]: 15, [Stat.SPEED]: 10 },
  [Item.SCOPE_LENS]: { [Stat.PP]: 15, [Stat.CRIT_CHANCE]: 25 },
  [Item.STAR_DUST]: { [Stat.SPE_DEF]: 10, [Stat.PP]: 15 },
  [Item.GREEN_ORB]: { [Stat.HP]: 15 },
  [Item.DEEP_SEA_TOOTH]: { [Stat.ATK]: 7, [Stat.PP]: 15 },
  [Item.SMOKE_BALL]: { [Stat.CRIT_CHANCE]: 10 },
  [Item.XRAY_VISION]: { [Stat.SPEED]: 50 },
  [Item.RAZOR_FANG]: {
    [Stat.SPEED]: 10,
    [Stat.CRIT_CHANCE]: 10,
    [Stat.CRIT_POWER]: 100
  },
  [Item.LOADED_DICE]: { [Stat.SPEED]: 10, [Stat.SPE_DEF]: 3, [Stat.LUCK]: 30 },
  [Item.PUNCHING_GLOVE]: { [Stat.SPEED]: 10, [Stat.ATK]: 3 },
  [Item.MUSCLE_BAND]: { [Stat.SPEED]: 10, [Stat.DEF]: 3 },
  [Item.STICKY_BARB]: { [Stat.DEF]: 6, [Stat.HP]: 15 },
  [Item.ABILITY_SHIELD]: { [Stat.AP]: 10 },
  [Item.WIDE_LENS]: {
    [Stat.RANGE]: 2,
    [Stat.CRIT_CHANCE]: 15,
    [Stat.SPE_DEF]: 3
  },
  [Item.RAZOR_CLAW]: { [Stat.CRIT_CHANCE]: 50, [Stat.ATK]: 3 },
  [Item.SAFETY_GOGGLES]: { [Stat.CRIT_CHANCE]: 10, [Stat.DEF]: 3 },
  [Item.KINGS_ROCK]: { [Stat.HP]: 100 },
  [Item.SHINY_CHARM]: { [Stat.DEF]: 3 },
  [Item.PROTECTIVE_PADS]: { [Stat.SHIELD]: 60, [Stat.ATK]: 6 },
  [Item.ASSAULT_VEST]: { [Stat.SPE_DEF]: 40 },
  [Item.AMULET_COIN]: {},
  [Item.POKE_DOLL]: { [Stat.DEF]: 3, [Stat.SPE_DEF]: 3 },
  [Item.RED_ORB]: { [Stat.ATK]: 10 },
  [Item.FLAME_ORB]: { [Stat.ATK]: 5, [Stat.DEF]: 3 },
  [Item.ROCKY_HELMET]: { [Stat.DEF]: 25 },
  [Item.MAGMARIZER]: { [Stat.ATK]: 5 },
  [Item.MACHO_BRACE]: { [Stat.ATK]: 15, [Stat.SPEED]: -15 },
  [Item.LIGHT_BALL]: { [Stat.AP]: 50 },
  [Item.DRAGON_SCALE]: { [Stat.DEF]: 5, [Stat.SPE_DEF]: 5 },
  [Item.METRONOME]: { [Stat.PP]: 5 },
  [Item.METAL_COAT]: { [Stat.DEF]: 10, [Stat.SPE_DEF]: 10 },
  [Item.AIR_BALLOON]: { [Stat.SPEED]: 30 },
  [Item.EXPLORER_KIT]: { [Stat.DEF]: 5, [Stat.SPE_DEF]: 5, [Stat.ATK]: 3 },
  [Item.PROTECTOR]: { [Stat.SHIELD]: 75 },
  [Item.BERSERK_GENE]: { [Stat.ATK]: 10 },
  [Item.SURFBOARD]: { [Stat.SPEED]: 30 },
  [Item.TERRAIN_EXTENDER]: { [Stat.SHIELD]: 50, [Stat.PP]: 20 },
  [Item.INCENSE]: { [Stat.SPE_DEF]: 10, [Stat.LUCK]: 30 },
  [Item.COOKING_POT]: { [Stat.DEF]: 10 },
  [Item.RUNNING_SHOES]: { [Stat.SPEED]: 15 },
  [Item.EVIOLITE]: {
    [Stat.HP]: 100,
    [Stat.ATK]: 10,
    [Stat.AP]: 50,
    [Stat.DEF]: 10,
    [Stat.SPE_DEF]: 10
  },
  [Item.GOLD_BOTTLE_CAP]: {
    [Stat.LUCK]: 50,
    [Stat.CRIT_CHANCE]: 30
  },
  [Item.COMET_SHARD]: { [Stat.ATK]: 15 },
  [Item.SHINY_STONE]: { [Stat.AP]: 50 },
  [Item.ABSORB_BULB]: { [Stat.DEF]: 20, [Stat.SPE_DEF]: 20 },
  [Item.GOLD_BOW]: { [Stat.SHIELD]: 50 },
  [Item.TEAL_MASK]: { [Stat.SHIELD]: 100, [Stat.SPEED]: 30 },
  [Item.WELLSPRING_MASK]: { [Stat.SHIELD]: 100, [Stat.SPE_DEF]: 10 },
  [Item.CORNERSTONE_MASK]: { [Stat.SHIELD]: 100, [Stat.DEF]: 10 },
  [Item.HEARTHFLAME_MASK]: { [Stat.SHIELD]: 100, [Stat.ATK]: 10 },
  [Item.SILK_SCARF]: { [Stat.SHIELD]: 15 },
  [Item.FRIEND_BOW]: { [Stat.SHIELD]: 30 },
  [Item.BLACK_BELT]: { [Stat.SHIELD]: 15, [Stat.CRIT_CHANCE]: 20 },
  [Item.LUCKY_RIBBON]: { [Stat.DEF]: 10, [Stat.AP]: 50, [Stat.LUCK]: 30 },
  [Item.EXPLOSIVE_BAND]: { [Stat.SHIELD]: 50, [Stat.ATK]: 3 },
  [Item.TWIST_BAND]: { [Stat.SPE_DEF]: 20, [Stat.SHIELD]: 50 },
  [Item.BIG_EATER_BELT]: { [Stat.HP]: 50, [Stat.SHIELD]: 15 },
  [Item.MACH_RIBBON]: { [Stat.SHIELD]: 15, [Stat.SPEED]: 10 },
  [Item.COVER_BAND]: { [Stat.DEF]: 12, [Stat.SHIELD]: 50 },
  [Item.EFFICIENT_BANDANNA]: { [Stat.SHIELD]: 15, [Stat.PP]: 15 },
  [Item.NULLIFY_BANDANNA]: { [Stat.SHIELD]: 30 }
}

export const ItemSellPricesAtTown: { [item in ItemsSoldAtTown]?: number } = {
  [Item.TINY_MUSHROOM]: 1,
  [Item.BIG_MUSHROOM]: 2,
  [Item.BALM_MUSHROOM]: 5
}
